import React from "react";
import Card from "@rio-cloud/rio-uikit/Card";
import { Button } from "@rio-cloud/rio-uikit";
import { useT } from "@hooks";

const UnauthorizedScreen = () => {
  const t = useT();

  const handleBackToHome = () => {
    window.location.href = "https://home.rio.cloud";
  };

  return (
    <div className="display-flex align-items-center justify-content-center" style={{ minHeight: "calc(100vh - 54px)" }}>
      <Card
        style={{ padding: "60px 80px", width: 720, height: 440 }}
        className="text-center display-flex flex-column align-items-center justify-content-center"
      >
        <div className="margin-bottom-25 display-flex justify-content-center">
          <span className="rioglyph rioglyph-ban-circle" style={{ fontSize: 96, color: "#D0D8DE" }} />
        </div>
        <h2 className="text-center margin-bottom-10 text-size-h3">{t("unauthorized.title")}</h2>
        <p className="text-center text-color-gray margin-bottom-25 text-size-14">
          {t("unauthorized.description")}
          <br />
          {t("unauthorized.contactMessage")}
        </p>
        <Button bsStyle={Button.PRIMARY} onClick={handleBackToHome}>
          {t("unauthorized.backToHome")}
        </Button>
      </Card>
    </div>
  );
};

export default UnauthorizedScreen;
